import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { IncreaseOriginalValueMain } from './IncreaseOriginalValueMain'
import { IncreaseOriginalValueForm } from './IncreaseOriginalValueForm/IncreaseOriginalValueForm'
import { IncreaseOriginalValueDetail } from './IncreaseOriginalValueDetail/IncreaseOriginalValueDetail'

const increaseOriginalValueRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/increase-original-value/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/increase-original-value',
    },
    component: <IncreaseOriginalValueMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/increase-original-value/add',
    },
    component: (
      <IncreaseOriginalValueForm formMode="add" type="ASSETS_REGISTRATION" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/increase-original-value/edit',
    },
    component: <IncreaseOriginalValueForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/increase-original-value/resubmit',
    },
    component: <IncreaseOriginalValueForm formMode="resubmit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/increase-original-value/detail',
    },
    component: <IncreaseOriginalValueDetail />,
  },
]

export default increaseOriginalValueRoutes
